import { useEffect, useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_EXERCISE_GROUPS_DATES } from "../../../api/apiRoutes";
import { Assort } from "../../../models/Assort";
import { Exercise } from "../../../models/Exercise";
import getId from "../../../../utils/getId";
import { format } from "date-fns";

export class Hours {
  constructor(data: any) {
    this.time = data.time;
    this.days = data.days;
  }
  time: string;
  days: Days[];
}
export class Days {
  constructor(data: any) {
    this.day = data.day;
    this.exercise = data.exercise;
  }
  day: string;
  exercise: Exercise[];
}

export default function useAdditionalHooks(
  sortByExerciseGroup: (value: number) => void,
  resetSortByExerciseGroup: () => void,
  dateFromState: Date,
  dateToState: Date
) {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [exerciseGroups, setExerciseGroups] = useState<Assort[]>([]);
  const [selectedExerciseGroupId, setSelectedExerciseGroupId] = useState<Assort>({} as Assort);

  useEffect(() => {
    if (getId(selectedExerciseGroupId)) {
      sortByExerciseGroup(selectedExerciseGroupId.objectId);
    }
    // eslint-disable-next-line
  }, [selectedExerciseGroupId]);

  const handleResetSelectedExercise = () => {
    setSelectedExerciseGroupId({} as Assort);
    resetSortByExerciseGroup();
  };

  const getExerciseGroups = async () => {
    const { result, isError } = await get(
      GET_EXERCISE_GROUPS_DATES(
        facilityIds,
        format(dateFromState, "yyyy-MM-dd"),
        format(dateToState, "yyyy-MM-dd"),
        "fitness"
      )
    );
    if (!isError) {
      setExerciseGroups(result);
    }
  };

  return {
    getExerciseGroups,
    exerciseGroups,
    setSelectedExerciseGroupId,
    selectedExerciseGroupId,
    handleResetSelectedExercise,
  };
}
